import React, { useRef } from 'react'; import { DoubleSide } from 'three';
import { useGLTF } from '@react-three/drei'

export function AnA(props) {
    const group = useRef()
    const { nodes } = useGLTF('3ds/an/AnA.gltf')
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="AnA"
                geometry={nodes.AnA.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    )
}

useGLTF.preload('3ds/an/AnA.gltf')